/**
 * RequireAdminAuth
 * Route guard that enforces the admin auth flow:
 * 1. Must be logged in with Auth0
 * 2. Must have passed email verification
 * 3. Must have a valid admin token
 */

import { ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAdminAuthStore } from '@/stores/adminAuthStore';

interface RequireAdminAuthProps {
  children: ReactNode;
}

export function RequireAdminAuth({ children }: RequireAdminAuthProps) {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();
  const { emailVerified, adminToken } = useAdminAuthStore();

  // Still loading auth0 session
  if (isLoading) {
    return null;
  }

  // Not authenticated — redirect to Auth0 login
  if (!isAuthenticated) {
    loginWithRedirect();
    return null;
  }

  // Authenticated but not past email gate — redirect
  if (!emailVerified) {
    window.location.href = '/email-gate';
    return null;
  }

  // Passed email gate but no admin token — redirect
  if (!adminToken) {
    window.location.href = '/token-gate';
    return null;
  }

  // All gates passed — render children
  return <>{children}</>;
}
